import axios from 'axios';

export default {
    methods: {
        async eventoList(ok, err) {
            try {
                let r = await axios.post('stock/evento/list');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async eventoIndex(d) {
            try {
                let r = await axios.get('stock/evento?page=' + d.page, {params: d})
                return r.data
            } catch (e) {
                return e
            }
        },
        async eventoStore(d, ok, err) {
            try {
                let r = await axios.post('stock/evento', d)
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async eventoShow(id, ok, err) {
            try {
                let r = await axios.get('stock/evento/' + id)
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async eventoUpdate(d, ok, err) {
            try {
                let r = await axios.put('stock/evento/' + d.id, d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async eventoContadoStock(d, ok, err) {
            try {
                let r = await axios.post('stock/evento/contado-stock', d)
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async eventoReferencias(d, ok, err) {
            try {
                let r = await axios.post('stock/evento/referencias', d)
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/stock/evento.js